"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var AggregateChangeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AggregateChangeComponent, _super);
    function AggregateChangeComponent(props, context) {
        return _super.call(this, props, context) || this;
    }
    AggregateChangeComponent.prototype.render = function () {
        var _a = this.props, children = _a.children, name = _a.name, checked = _a.checked, onChange = _a.onChange;
        return React.Children.map(children, function (child, idx) {
            if (!child) {
                return child;
            }
            return React.cloneElement(child, {
                name: name || child.props.name,
                checked: checked ? checked === child.props.value : child.props.checked,
                onChange: child.props.onChange || onChange
            });
        });
    };
    AggregateChangeComponent.defaultProps = {};
    return AggregateChangeComponent;
}(React.Component));
exports.default = AggregateChangeComponent;
